import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import WithDesktopShopDetails from '@shopDetails/HOCs/WithDesktopShopDetails';
import getHasFetchedShop from '@core/reducers/shop/selectors/getHasFetchedShop';
import getIsMenuFetched from '@core/reducers/menu/selectors/getIsMenuFetched';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import trackProductSearch from '@conversion/tracking/actions/trackProductSearch';
import getExtendedMenuSelectedSection from '@shopDetails/selectors/getExtendedMenuSelectedSection';
import extendedMenuSectionChanged from '@shopDetails/actions/extendedMenuSectionChanged';
import fetchMeasurementUnitsList from '@shopDetails/actions/fetchMeasurementUnitsList';
import { getShopBusinessType } from '@shopDetails/selectors';
import fetchPreferredDishes from '@shopDetails/actions/fetchPreferredDishes';
import getIsFetchingPreferredDishes from '@shopDetails/selectors/getIsFetchingPreferredDishes';
import { getIsUserLogged } from '@shared/selectors';

const mapStateToProps = createStructuredSelector({
  hasFetchedShop: getHasFetchedShop,
  hasFetchedMenu: getIsMenuFetched,
  selectedSection: getExtendedMenuSelectedSection,
  businessType: getShopBusinessType,
  isUserLogged: getIsUserLogged,
  isFetchingPreferredDishes: getIsFetchingPreferredDishes,
  togglePickup: getCartIsPickUp,
});
const mapDispatchToProps = {
  trackProductSearch,
  extendedMenuSectionChanged,
  fetchMeasurementUnitsList,
  fetchPreferredDishes,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withShopDetails = T => WithDesktopShopDetails(T);

export default compose(withShopDetails, withConnect);
